import { __module as e } from "./index.es10.js";
import { __require as r } from "./index.es11.js";
import { __require as o } from "./index.es12.js";
process.env.NODE_ENV === "production" ? e.exports = r() : e.exports = o();
var m = e.exports;
export {
  m as j
};
//# sourceMappingURL=index.es3.js.map
